<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [header]="actionFlow()?.title | translate"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [closable]="loading() !== true"
  [closeOnEscape]="loading() !== true"
  (onHide)="actionButtonClick.emit('CANCEL')">
  <div *ngIf="!actionFlow()?.descriptionAsHtml">{{ actionFlow()?.description | translate }}</div>
  <div *ngIf="actionFlow()?.descriptionAsHtml" [innerHTML]="actionFlow()?.description"></div>
  <ng-template pTemplate="footer">
    <div class="flex justify-start">
      <button
        *ngFor="let actionButton of actionFlow()?.buttons"
        type="button"
        pButton
        [label]="actionButton.label | translate"
        [loading]="actionButton.type !== 'CANCEL' && loading()"
        [disabled]="actionButton.type !== 'SUBMIT' && loading()"
        (click)="handleActionButtonClick(actionButton.type)"
        [ngClass]="{
          'p-button-outlined': actionButton.type === 'CANCEL'
        }"></button>
    </div>
  </ng-template>

  <ng-template #placeholder>
    <p-skeleton width="w-full" styleClass="p-6"></p-skeleton>
  </ng-template>

  <ng-template pTemplate="closeicon">
    <div
      class="p-dialog-header-icon"
      [title]="
        'dialog.button.close'
          | translate
            : {
                '0': actionFlow()?.title | translate
              }
      ">
      <i class="fa-regular fa-xmark text-lg text-gray-800"></i>
    </div>
  </ng-template>
</p-dialog>
